export default "__VITE_ASSET__Ct74MOWj__"